"use strict";
//@ts-nocheck
/*global $*/
/*global window*/
/*global document*/
/*global console*/
/*global setTimeout*/
/*global TYPO3*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.txGs1Base = void 0;
/**
 * GS1 Base
 *
 * @namespace
 * @public
 */
exports.txGs1Base = {};
/**
 * The jRespond object
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
exports.txGs1Base.respond = require('jrespond')([
    {
        label: 'handheld',
        enter: 0,
        exit: 480
    }, {
        label: 'tablet_portrait',
        enter: 480,
        exit: 767
    }, {
        label: 'tablet_landscape',
        enter: 768,
        exit: 991
    }, {
        label: 'desktop',
        enter: 992,
        exit: 10000
    }
]);
/** register enter and exit functions for desktop breakpoint
 *
 * @memberOf txGs1Base.respond
 * @type {*}
 */
exports.txGs1Base.respond.addFunc({
    breakpoint: ['handheld', 'tablet_portrait', 'tablet_landscape'],
    enter: function () {
        'use strict';
        $('[data-class-handheld]').each(function (index, item) {
            $(item).addClass($(item).data('classHandheld'));
        });
    },
    exit: function () {
        'use strict';
        $('[data-class-handheld]').each(function (index, item) {
            $(item).removeClass($(item).data('classHandheld'));
        });
    }
});
/** register enter and exit functions for desktop breakpoint
 *
 * @memberOf txGs1Base.respond
 * @type {*}
 */
exports.txGs1Base.respond.addFunc({
    breakpoint: ['desktop'],
    enter: function () {
        'use strict';
        $('[data-class-desktop]').each(function (index, item) {
            $(item).addClass($(item).data('classDesktop'));
        });
    },
    exit: function () {
        'use strict';
        $('[data-class-desktop]').each(function (index, item) {
            $(item).removeClass($(item).data('classDesktop'));
        });
    }
});
/**
 * Language object.
 * Detect current language and get localized labels.
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
exports.txGs1Base.language = {
    currentLanguage: 'default',
    labels: {
        'default': {
            'close': 'Schließen',
            'forward': 'Vor',
            'info': 'Info',
            'privacy_headline': 'Hinweis zum Datenschutz',
            'privacy_info_youtube': '<p>Bitte bestätigen Sie die Aktivierung dieses Videos.</p><p class="small">Nach der Aktivierung werden Cookies gesetzt und Daten an YouTube (Google) übermittelt.<br><a class="external-link" href="https://www.google.de/intl/de/policies/privacy/" target="_blank">Zur Datenschutzerklärung von Google</a></p>',
            'privacy_button_youtube_yes': 'Ja, Video anzeigen!',
            'privacy_button_youtube_no': 'Nein, Video nicht anzeigen.',
            'privacy_cookie_youtube': 'Alle Videos auf der GS1 Germany Website aktivieren',
        },
        'en': {
            'close': 'Close',
            'forward': 'Forward',
            'info': 'Information',
            'privacy_headline': 'Privacy information',
            'privacy_info_youtube': '<p>Please confirm video activation.</p><p class="small">After activation, cookies will be set and data is sent to YouTube/Google.<br><a class="external-link" href="https://www.google.de/intl/en/policies/privacy/" target="_blank">To the Google Privacy Policy</a><p>',
            'privacy_button_youtube_yes': 'Yes, play the video!',
            'privacy_button_youtube_no': 'No, do not play the video.',
            'privacy_cookie_youtube': 'Activate all videos on the GS1 Germany website',
        }
    },
    /**
     * Detect and set the current language.
     */
    initialize: function () {
        'use strict';
        if (typeof language !== 'undefined') {
            exports.txGs1Base.language.currentLanguage = language;
        }
    },
    /**
     * Return text for incoming key in current language.
     *
     * @param string labelKey The key of the label to return
     * @returns string The text in current language
     */
    getLabel: function (labelKey) {
        'use strict';
        return exports.txGs1Base.language.labels[exports.txGs1Base.language.currentLanguage][labelKey];
    }
};
$(function () {
    'use strict';
    // Create global objects
    window.gs1 = {};
    TYPO3.lang = TYPO3.lang || {};
    TYPO3.settings = TYPO3.settings || {};
    exports.txGs1Base.select2.initialize();
    exports.txGs1Base.images.initialize();
    exports.txGs1Base.registration.initialize();
    exports.txGs1Base.readmore.initialize();
    exports.txGs1Base.login.initialize();
    exports.txGs1Base.prg.initialize();
    let seminarDescriptionPrint = document.getElementsByClassName('seminar-description-print');
    if (seminarDescriptionPrint.length === 0) {
        exports.txGs1Base.academyEventPanels.initialize();
    }
    exports.txGs1Base.publications.initialize();
    exports.txGs1Base.filter.initialize();
    exports.txGs1Base.onClickEvents.initialize();
    // txGs1Base.protectedDownloads.initialize();
    // txGs1Base.blockquotes.initialize();
    // txGs1Base.rteButtons.initialize();
    // txGs1Base.forms.initialize();
    // txGs1Base.accordion.initialize();
    // txGs1Base.accordion.initialize();
    // txGs1Base.content.initialize();
    // txGs1Base.panels.filter.initialize();
    // txGs1Base.toTopLink.initialize();
    // txGs1Base.topCartSearch.initialize();
    // txGs1Base.download.initialize();
    // txGs1Base.print.initialize();
    // txGs1Base.ttAddress.initialize();
    // txGs1Base.navigation.initialize();
    // txGs1Base.foldout.initialize();
    // txGs1Base.language.initialize();
    // txGs1Base.privacy.initialize();
    // txGs1Base.smoothScrolling.initialize();
    // txGs1Base.onepagerNavigation.initialize();
});
exports.default = {};
